import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

/**
 * 设备台账管理API服务
 */
export const deviceService = {
  /**
   * 获取设备统计信息
   */
  getDeviceStatistics: () => axios.get(`${iffApi}/device/statistics`, { params: { } }),

  /**
   * 分页查询设备列表
   * @param {Object} params 查询参数
   */
  queryDevicePage: (params) => axios.get(`${iffApi}/device/page`, { params: params }),

  /**
   * 获取设备详情
   * @param {String} uuid 设备ID
   */
  getDeviceDetail: (uuid) => axios.get(`${iffApi}/device/detail/${uuid}`),

  /**
   * 新增设备（仅创建，不传 uuid）
   * @param {Object} data 设备信息
   */
  addDevice: (data) => axios.post(`${iffApi}/device/save`, data),

  /**
   * 更新设备（uuid 必填）
   * @param {Object} data 设备信息
   */
  updateDevice: (data) => axios.post(`${iffApi}/device/update`, data),

  /**
   * 删除设备
   * @param {String} uuid 设备ID
   */
  deleteDevice: (uuid) => axios.delete(`${iffApi}/device/delete/${uuid}`),

  /**
   * 按查询条件批量删除设备
   * 参数与列表查询一致，删除当前查询范围内的全部设备
   * @param {Object} queryVO 查询条件
   */
  batchDeleteDevice: (queryVO) => axios.post(`${iffApi}/device/batchDelete`, queryVO),

  /**
   * 绑定NFC标签
   * @param {String} deviceId 设备ID
   * @param {String} nfcTagId NFC标签ID
   */
  bindNfcTag: (deviceId, nfcTagId) => axios.post(`${iffApi}/device/bindNfc`, { deviceId, nfcTagId }),

  /**
   * 解绑NFC标签
   * @param {String} deviceId 设备ID
   */
  unbindNfcTag: (deviceId) => axios.post(`${iffApi}/device/unbindNfc`, { deviceId }),

  // ==================== 导入导出相关接口 ====================

  /**
   * 下载设备导入模板
   */
  downloadTemplate: () => axios.get(`${iffApi}/device/getExcelMb`, { responseType: 'blob' }),

  /**
   * 导入设备数据
   * @param {FormData} formData
   */
  importDevice: (formData) => axios.post(`${iffApi}/device/importExcel`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),

  /**
   * 导出设备数据
   * @param {Object} params 查询参数
   */
  exportDevice: (params) => axios.post(`${iffApi}/device/exportExcel`, params, { responseType: 'blob' }),

  // ==================== 统计视图相关接口 ====================

  /**
   * 设备系统分布统计（统计视图主图表数据）
   * 返回 { areaNames, systems: [{ systemId, systemName, areaCounts, totalCount }] }
   */
  getSystemDistribution: () => axios.get(`${iffApi}/device/stats/system-distribution`),

  /**
   * 设备类型分布统计（二级下钻）
   * @param {String} systemId 消防系统ID
   * 返回 { areaNames, types: [{ deviceTypeId, deviceTypeName, areaCounts, totalCount }] }
   */
  getTypeDistribution: (systemId) => axios.get(`${iffApi}/device/stats/type-distribution`, { params: { systemId } }),

  /**
   * 导出设备数量统计矩阵（消防系统 × 一级区域）
   * 服务端模板模型：areaNames、rows（每行 DeviceSystemMatrixExportRowVO，含末行合计）
   */
  exportSystemDistributionMatrix: () =>
    axios.get(`${iffApi}/device/stats/system-distribution/export`, { responseType: 'blob' })
};
